<template>
    <div class="page-wrapper">
        <search-list
            ref="search-list"
            @findData="updateTable"
            @clear="updateParams"></search-list>
        <div class="page-wrapper">
            <table-list
                :columns="columns"
                :data="data"
                :total="total"
                :current="current"
                :loading="loading"
                @change-page="changePage" @on-selection-change="getSelect">
                <Button
                    class="mb16"
                    type="primary" @click="exportHander"
                    v-p="{api:'cooperation/exportCooperationList'}"
                >导出商机</Button>
                <div class="tooltip-wrapper">
                    <Tooltip
                        placement="top"
                        content="请先勾选一行"
                        :disabled="selectionFids.length !== 0">
                        <Button
                            class="mb16"
                            type="primary"
                            :disabled="selectionFids.length === 0"
                            @click="distributionHander"
                      v-p="{api:'cooperation/allocateCooperation'}"
                      >分配商机</Button>
                    </Tooltip>
                </div>

            </table-list>
        </div>
        <info-modal
            v-model="show"
            :id="fid"
            @refresh="initTable(params)"></info-modal>
        <info-modal
            v-model="look"
            :edit="false"
            title="查看商机"
            :id="fid"></info-modal>
        <assign-modal
            v-model="showAssign"
            :fids="selectionFids"
            @refresh="initTable(params)"></assign-modal>
    </div>
</template>

<script type="text/ecmascript-6">
import SearchList from "./components/SearchList";
import TableList from "components/TableList/index";
import { cooperationList,exportList } from "@/api/ownerShip";
import InfoModal from './components/Infomodal';
import AssignModal from './components/Assignmodal';

export default {
    name: "ownership",
    data() {
        return {
            columns: [
                {
                type: "selection",
                width: 60,
                align: "center"
                },
                {
                title: "商机状态",
                align: "center",
                width: 100,
                key: "handleStatusName"
                },
                {
                title: "物业负责人",
                align: "center",
                width: 100,
                key: "name"
                },
                {
                title: "物业负责人电话",
                align: "center",
                width: 150,
                key: "phone"
                },
                {
                  title: "物业类型",
                  align: "center",
                  width: 100,
                  key: "propertyTypeName"
                },
                {
                title: "城市",
                align: "center",
                width: 100,
                key: "cityName"
                },
                {
                title: "创建时间",
                align: "center",
                width: 200,
                key: "createTime"
                },
                {
                title: "来源渠道",
                align: "center",
                width: 200,
                key: "sourceName"
                },
                {
                title: "跟进人",
                align: "center",
                width: 100,
                key: "currentHandler"
                },
                {
                title: "最新跟进内容",
                align: "center",
                width: 200,
                key: "lastHandleRecord"
                },
                {
                title: "推荐人",
                align: "center",
                width: 100,
                key: "refereeName"
                },
                {
                title: "推荐人电话",
                align: "center",
                width: 200,
                key: "refereeMobile"
                },
                {
                title: "操作",
                width: 150,
                key: "action",
                align: "center",
                fixed: "right",
                render: (h, params) => {
                    return h("div", {}, [
                    h(
                        "Button",
                        {
                        props: {
                            type: "primary",
                            size: "small"
                        },
                        style: {
                            marginRight: "5px"
                        },
                        on: {
                            click: () => {
                                this.fid = params.row.fid
                                this.look = true
                            }
                        }
                        },
                        "查看"
                    ),
                    h(
                        "Button",
                        {
                        props: {
                            type: "primary",
                            size: "small",
                            disabled: params.row.handleStatus === 5 || params.row.handleStatus === 6
                        },
                        directives:[
                            {
                                name:'p',
                                value:{
                                    api:'cooperation/handleCooperation'
                                }
                            }
                        ],
                        on: {
                            click: () => {
                                this.fid = params.row.fid
                                this.show = true
                            }
                        }
                        },
                        "处理"
                    )
                    ]);
                }
                }
            ],
            data: [],
            total: 0,
            current: 1,
            loading: false,
            params: {
                page: 1,
                limit: 10,
                cityName: null,
                source: null,
                createTime: null,
                handleStatus: null,
                currentHandler: null,
                condition: null,
                startTime:null,
                endTime:null,
            },
            show:false,
            look:false,
            showAssign:false,
            fid:null,
            selectionFids:[],
        };
    },
  created() {
    this.initTable(this.params);
  },
  components: {
    SearchList,
    TableList,
    InfoModal,
    AssignModal
  },
  methods: {
    changePage(n) {
      this.current = n;
      this.params.page = n;
      this.initTable(this.params);
    },
    initTable(params) {
        this.selectionFids = [];
        cooperationList(params).then(res => {
            this.data = res.data.rows;
            this.total = res.data.total;
            if (res.data.total === 0) {
                this.current = 1;
            }
        });
    },
    updateTable(params) {
      this.current = 1;
      Object.assign(this.params, params);
      this.initTable(params);
    },
    getSelect(selection) {
        this.selectionFids = selection.map(item => item.fid);
    },
    distributionHander() {
        this.showAssign = true;
    },
    exportHander() {
        exportList(this.params).then(res => {
            let fileName = res.headers.filename || 'excel.xls'
            let blob = new Blob([res.data])
            let url = window.URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
        })
    },
    updateParams(params) {
        this.params = JSON.parse(JSON.stringify(params)) ;
        console.log(this.params);
    }
  }
};
</script>

<style scoped>
.tooltip-wrapper{
    display: inline-block;
}
</style>
